const suiteStakes = {
  "heading": "AT&T THANKS® wants to help pay your wireless bill",
  "bodyCopy": "Think less about your wireless bill. Think more about your weekend. Enter for your chance to win a year of AT&T wireless service (up to $250/mo.).",
  "cta": {
    "label": "ENTER NOW",
    "id": "enter-now",
    "href": "https://attthanks.att.com/winwireless2021/redemption",
    "color": "primary"
  },
  "disclaimer": ""
}

module.exports = suiteStakes;
